import Input from "../../Input"

const AutoOs = ({ values, serverData }) => {
    return (
        <div className="mx-14 h-full">
            <h6 className="flex justify-center">سیستم عامل اتومات</h6>
            <div>
                <Input
                    type="text"
                    label="ایدی رنک ها برای چشم پوشی"
                    name="autoOs-ignoreSgList"
                    placeholder="مثال: 1,2,3"
                    options={serverData?.sgList}
                    multi={true}
                    autoComplete="off"
                    defaultValue={values?.ignoreSgList}
                    dir="ltr"
                />
            </div>
            <div className="grid grid-cols-4 gap-5 mt-2">
                <div className="">
                    <Input
                        type="number"
                        label="رنک ویندوز"
                        name="autoOs-windows"
                        placeholder="sgID"
                        options={serverData?.sgList}
                        autoComplete="off"
                        defaultValue={values?.windows}
                        dir="ltr"
                    />
                </div>
                <div className="">
                    <Input
                        type="text"
                        name="autoOs-mac"
                        label="رنک مک"
                        options={serverData?.sgList}
                        placeholder="sgID"
                        defaultValue={values?.mac}
                        autoComplete="off"
                        dir="ltr"
                    />
                </div>
                <div className="">
                    <Input
                        type="text"
                        label="رنک لینوکس"
                        name="autoOs-linux"
                        placeholder="sgID"
                        options={serverData?.sgList}
                        autoComplete="off"
                        defaultValue={values?.linux}
                        dir="ltr"
                    />
                </div>
                <div className="">
                    <Input
                        type="text"
                        label="رنک اندروید"
                        name="autoOs-android"
                        placeholder="sgID"
                        options={serverData?.sgList}
                        autoComplete="off"
                        defaultValue={values?.android}
                        dir="ltr"
                    />
                </div>
                <div className="">
                    <Input
                        type="text"
                        label="رنک آیفون"
                        name="autoOs-iOS"
                        placeholder="sgID"
                        options={serverData?.sgList}
                        autoComplete="off"
                        defaultValue={values?.iOS}
                        dir="ltr"
                    />
                </div>
            </div>
        </div>
    )
}

export default AutoOs
